const DemoExplorer = () => import('@/views/demo/DemoExplorer.vue')
const DashboardMobile = () => import('@/views/DashboardMobile.vue')

/**
 * [pathSuffix sem barra inicial, chave richContent, título no browser/menu]
 * (sem mobile/dashboard — usa o mesmo DashboardMobile do painel real)
 */
const DEMO_SCREENS = [
  ['mobile/whatsapp-chat', 'whatsappChat', 'WhatsApp — chats'],
  ['mobile/whatsapp-audio', 'whatsappAudio', 'WhatsApp — áudios'],
  ['mobile/whatsapp-call', 'whatsappCall', 'WhatsApp — chamadas'],
  ['mobile/instagram-chat', 'instagramChat', 'Instagram'],
  ['mobile/telegram-chat', 'telegramChat', 'Telegram'],
  ['mobile/tinder-chat', 'tinderChat', 'Tinder'],
  ['mobile/kwai-chat', 'kwaiChat', 'Kwai'],
  ['mobile/badoo-chat', 'badooChat', 'Badoo'],
  ['mobile/snapchat-chat', 'snapchatChat', 'Snapchat'],
  ['mobile/apps', 'mobileApps', 'Aplicativos instalados'],
  ['mobile/chamadas', 'mobileCalls', 'Chamadas telefônicas'],
  ['mobile/teclas', 'keylogger', 'Teclas digitadas'],
  ['mobile/contatos', 'contacts', 'Contatos'],
  ['mobile/sites', 'webHistory', 'Histórico web'],
  ['mobile/pesquisas', 'webSearch', 'Pesquisas no navegador'],
  ['mobile/sms-chat', 'smsChat', 'SMS'],
  ['mobile/localizacao', 'location', 'Localização GPS'],
  ['mobile/zona-segura', 'safeZone', 'Zona segura'],
  ['mobile/photogallery', 'photoGallery', 'Galeria de fotos'],
  ['mobile/screenshot', 'screenshot', 'Capturas de tela'],
  ['mobile/foto-remota', 'remotePhoto', 'Foto remota'],
  ['mobile/remotephoto', 'remotePhotoV2', 'Foto remota (v2)'],
  ['mobile/microfone', 'microphone', 'Microfone ambiente'],
  ['desktop/dashboard', 'desktopDashboard', 'Painel computador'],
  ['desktop/sites', 'desktopSites', 'Sites (computador)'],
  ['desktop/teclas', 'desktopKeys', 'Teclas (computador)'],
  ['desktop/pesquisas', 'desktopSearch', 'Pesquisas (computador)'],
  ['desktop/telas', 'desktopScreens', 'Telas (computador)'],
  ['dispositivo', 'devices', 'Meus dispositivos'],
  ['subscriptions', 'subscriptions', 'Assinaturas'],
  ['novo-dispositivo', 'newDevice', 'Novo dispositivo'],
  ['transferir-licenca', 'transferLicence', 'Transferir licença'],
  ['transferir-dispositivos', 'transferDevices', 'Transferir dispositivos'],
  ['conta/perfil', 'accountProfile', 'Conta — perfil']
]

export const demoMainLayoutRoutes = [
  {
    path: '/demo',
    redirect: '/demo/mobile/dashboard'
  },
  {
    path: '/demo/mobile/dashboard',
    name: 'demo-dashboardMobile',
    component: DashboardMobile,
    meta: {
      rule: 'editor',
      pageTitle: 'Painel mobile (demonstração)'
    }
  },
  ...DEMO_SCREENS.map(([suffix, demoView, title]) => ({
    path: `/demo/${suffix}`,
    name: `demo-${demoView}`,
    component: DemoExplorer,
    meta: {
      rule: 'editor',
      pageTitle: `${title} (demonstração)`,
      demoView
    }
  }))
]
